module.exports = __webpack_public_path__ + "static/4-e1984e40535cf7bf32668b7c20f81d71.jpg";